export default __webpack_public_path__ + "static/silversWithBg-2c951b5ddd667936a477678e24bc0848.png";